import { createFeatureSelector, createSelector } from '@ngrx/store';
import { STORE_TYPE } from './onboarding-info.model';
import { IOnboardingInfoState } from './onboarding-info.state';

export const selectorState = createFeatureSelector<IOnboardingInfoState>(STORE_TYPE);

export const selectOnboardingInfoList = createSelector(selectorState, (state) => state.list);
export const selectOnboardingInfoLoading = createSelector(selectorState, (state) => state.isLoading);
export const selectSelectedOnboardingInfo = createSelector(selectorState, (state) => state.selected);
